import { Textarea, TextareaProps } from "@chakra-ui/react";
import React, { Ref } from "react";

import { TEXT_STYLES, textStylesType } from "src/typography";

import { TEXTAREA_STYLES } from "./styles";

export type Props = TextareaProps & { textStyle?: textStylesType };

export const OFTextarea = React.forwardRef(({ ...props }: Props, ref: Ref<HTMLTextAreaElement>) => {
  const textStyles = props.textStyle ? TEXT_STYLES[props.textStyle] : {};
  delete textStyles?.as;
  return (
    <Textarea
      fontFamily="graphik"
      sx={{ ...TEXTAREA_STYLES }}
      {...textStyles}
      {...props}
      fontSize="16px"
      ref={ref}
    />
  );
});
